import { useFilters } from "../../../../Components/Filters/Filters.hook";
import { ListIcon } from "shared-components/Components/CustomIcons/ListIcon/web";
import { LocationIconMap } from "shared-components/Components/CustomIcons/LocationIconMap/web";

export const ButtonMapToggle = ({ map, setMap, small = false }) => {
	const { changeFilters } = useFilters();

	if (small) {
		return (
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
				onClick={() => {
					let showMap = !map;
					changeFilters({ mapView: showMap });
					setMap(showMap);
				}}>
				{map?  <ListIcon width={25}/> : <LocationIconMap width={20}  />}
				<span style={{ height: '20px' }}>{map ? "Lista" : "Mapa"}</span>
			</div>
		)
	}

	return (
		<button
			className={`button ${!map ? "button-secondary order-filter-btn" : "button-secondary order-filter-btn-map"}`}
			onClick={() => {
				let showMap = !map;
				changeFilters({ mapView: showMap });
				// if (!showMap) changeFilters({ map_bounds: null, mapView: false, map_polygon: null }); MERGE PD: FINCA LO TRAÍA ASÍ VALIDAR Y BORRAR
				setMap(showMap);
			}}
		>
			{map?  <ListIcon width={25}/> : <LocationIconMap width={20}  />}
			{map ? "Ver Listado" : "Ver Mapa"}
		</button>
	);
};

